// Implements: F-MCK-021
/**
 * The explicit assignments of one mockup, for the share popover's "Personas con acceso" (mockup v3
 * P4). The same routes as the `mockups` client: a module may not import another, so `sharing` has
 * its own three calls. Writes are owner-only on the server and never retried.
 */

import { ApiError, UNKNOWN_ERROR_CODE } from "../../../shared/api/ApiError";
import { API_BASE } from "../../../shared/api/apiBase";
import { httpRequest } from "../../../shared/api/httpClient";
import type { AssignmentListView, MockupAssignmentView, MockupRole } from "../../../types/api";

function assignmentsPath(mockupId: string): string {
  return `${API_BASE}/mockups/${encodeURIComponent(mockupId)}/assignments`;
}

export async function fetchAssignments(
  mockupId: string,
  signal?: AbortSignal,
): Promise<readonly MockupAssignmentView[]> {
  const body = await httpRequest<Partial<AssignmentListView>>(assignmentsPath(mockupId), { signal });
  return body?.assignments ?? [];
}

export async function assignRole(
  mockupId: string,
  userId: string,
  role: Exclude<MockupRole, "owner">,
): Promise<MockupAssignmentView> {
  const body = await httpRequest<MockupAssignmentView>(`${assignmentsPath(mockupId)}/${encodeURIComponent(userId)}`, {
    method: "PUT",
    body: { role },
    retry: false,
  });
  if (body === undefined) throw new ApiError(200, UNKNOWN_ERROR_CODE, "PUT assignment answered with no body", new Headers());
  return body;
}

export async function revokeAssignment(mockupId: string, userId: string): Promise<void> {
  await httpRequest<unknown>(`${assignmentsPath(mockupId)}/${encodeURIComponent(userId)}`, {
    method: "DELETE",
    retry: false,
  });
}
